// extracted by mini-css-extract-plugin
export var quillEditor = "_gl-1";
export var variable = "_gl-0";